import ongCardComponent from './ongCard.component';
import ongCardDetails from './ongCardDetails/ongCardDetails';
import ongCardSwitch from './ongCardSwitch/ongCardSwitch';

let ongCardModule = angular.module('solidarity.ongCard', [
  ongCardDetails,
  ongCardSwitch,
])

.component('ongCard', ongCardComponent)

.name;

export default ongCardModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongCard/ongCard.js